const CONTENT_MAX_WIDTH = 1280;

export default {
  AMPLITUDE: {
    ON_CLICK: 'custom_list_click',
    ON_SHARE: 'social_share',
    ON_CHANGE_STORY: 'change_story',
    ON_CLOSE: 'close',
    ON_END_OF_STORY: 'end_of_story',
    ON_NAVIGATION_BACK: 'navigation_back',
    SUMMARY_STORY: 'summary_list',
    VIEW_STORY: 'page_view',

    CLICK_TYPE: {
      ANCHOR: 'anchor',
      IN: 'minube',
      OUT: 'clickout',
      LIST: 'list_click',
      STORIES_OPEN: 'related_list_open',
      STORIES_CLOSE: 'related_list_close',
      SUGGESTION_CLOSE: 'suggestion_close',
    },

    EVENT_SECTION: 'custom_list_view',

    VIEWING_GAP: 0.55,
    READING_GAP: 0.25,
  },

  CONTENT_MAX_WIDTH,

  DOMAINS: {
    co: 'en-GB',
    fr: 'fr-FR',
    it: 'it-IT',
    net: 'en-US',
    pt: 'pt-PT',
  },

  LANGUAGE: 'es-ES',

  MAX_PAGE_PRELOAD: 5,
  MINUBE: {
    LOGO: 'https://1.images.mnstatic.com/home/logo/minube_white.png',
    LOGO_GREY: 'https://imgs-akamai.mnstatic.com/misc/minube_grey.png',
    FAVICON: 'https://cdn.mnstatic.com/1/favicon/favicon.ico',
    FAVICON16: 'https://cdn.mnstatic.com/1/favicon/favicon-16x16.png',
    FAVICON32: 'https://cdn.mnstatic.com/1/favicon/favicon-32x32.png',
    SIGN: 'web_signed=o-2_r8)Rxo-2_r8)Rx',
    DOMAINS: {
      'es-ES': ['www.minube.com', 'staging-contents.minube.com', 'localhost:3000'],
      'fr-FR': ['www.monnuage.fr', 'staging-contents.monnuage.fr'],
      'it-IT': ['www.minube.it', 'staging-contents.minube.it'],
      'pt-PT': ['www.minube.pt', 'staging-contents.minube.pt'],
      'en-GB': ['www.minube.co.uk', 'staging-contents.minube.co.uk'],
      'en-US': ['www.minube.net', 'staging-contents.minube.ne'],
    },
  },

  PAGE_OFFSET: '7.5%',
  PAGE_OFFSET_HORIZONTAL: '10%',
  PAGE_BIG_OFFSET: '9.5%',
  PAGE_CONTENT: {
    alignSelf: 'center',
    maxWidth: CONTENT_MAX_WIDTH,
    width: '100%',
  },
  PAGE_HEADER_HEIGHT: 64,
  PAGE_TYPE: {
    CHAPTER: 'chapter',
    CONTENT: 'content',
    FOOTER: 'footer',
    GALLERY: 'gallery',
    MEDIA: 'media',
    SUGGESTION: 'suggestion',
    SLIDER: 'slider',
    TITLE: 'title',
  },
  CLIENT_DOMAINS: {
    EL_TIEMPO: {
      DOMAIN: 'destinosdeviaje.eltiempo.es',
      FAVICON: 'https://cdnbitmaps.eltiempo.es/images/favicon/eltiempo/16x16.png',
      FAVICON16: 'https://cdnbitmaps.eltiempo.es/images/favicon/eltiempo/16x16.png',
      FAVICON32: 'https://cdnbitmaps.eltiempo.es/images/favicon/eltiempo/16x16.png',
    },
    EROSKI: {
      DOMAIN: 'www.inspiracioneroski.com',
      FAVICON: 'https://www.viajeseroski.es/bundles/app/images/favicon/favicon-16x16.png',
      FAVICON16: 'https://www.viajeseroski.es/bundles/app/images/favicon/favicon-16x16.png',
      FAVICON32: 'https://www.viajeseroski.es/bundles/app/images/favicon/favicon-16x16.png',
    },
  },
};
